import { render, staticRenderFns } from "./additionalPointTypeChart.vue?vue&type=template&id=c6c71180&"
import script from "./additionalPointTypeChart.vue?vue&type=script&lang=js&"
export * from "./additionalPointTypeChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports